import { useState } from 'react';
import { Fields } from '@measured/puck';
import { MonacoEditor } from '../../components/monaco-editor/monaco-editor';
import Button from '../../../components/common/button';

export type MonacoHTMLEditorProps = {
  htmlContent: string;
};

export const MonacoHTMLEditor = (): Fields<MonacoHTMLEditorProps> => {
  return {
    htmlContent: {
      type: 'custom',
      render: ({ value, onChange }) => {
        const [isPopupOpen, setPopupOpen] = useState(false);
        const [editorValue, setEditorValue] = useState(value || '');

        const handleEditorChange = (newValue: string | undefined) => {
          if (newValue !== undefined) {
            setEditorValue(newValue);
          }
        };

        const handleSubmit = () => {
          onChange(editorValue);
        };

        return (
          <>
            <Button
              label="Open Code Editor"
              className="!p-2 !text-[16px] w-full"
              variant="phoenix_secondary"
              onClick={() => setPopupOpen(true)}
            />
            <MonacoEditor
              value={value || ''}
              handleEditorChange={handleEditorChange}
              isPopupOpen={isPopupOpen}
              setPopupOpen={setPopupOpen}
              language="html"
              handleSubmit={handleSubmit}
            />
          </>
        );
      },
    },
  };
};
